<div class="container">
    <h2>Corporate information</h2>
    <div class="A-Text-RichText">
        <p>
            <strong>
                Name and address
            </strong>
        </p>
        <p>
            Robert Bosch GmbH <br/>
            Robert-Bosch-Platz 1 <br/>
            70839 Gerlingen-Schillerhöhe <br/>
            GERMANY
        </p>
        <p>
            <strong>
                Members of the Board of Management
            </strong>
        </p>
        <p>
        Dr. Christian Fischer, Dr. Markus Forschner, Stefan Grosch, Dr. Markus Heyn, Dr. Frank Meyer, Katja von Raven, Dr. Tanja Rückert
        </p>
        <p>
            <strong>
                Your contact at Bosch
            </strong>
        </p>
        <p>
            <a
                target="_blank"
                aria-label="kontakt@bosch.de opens external site"
                rel="noopener, noreferrer"
                href="mailto:kontakt@bosch.de">
                <span>
                    kontakt@bosch.de
                    <i class="a-icon ui-ic-nosafe-lr-externallink"></i>
                </span>
            </a><br/>
            +49 711 400 40990
        </p>
        <p>
            <strong>
                Register Entries
            </strong>
        </p>
        <p>
            Registration Court: District Court Stuttgart HRB 14000
        </p>
        <p>
            <strong>
                Value-added tax identification number
            </strong>
        </p>
        <p>
            DE811128135
        </p>
        <p>
            <strong>
                Responsible in accordance with section 18 II of Germany’s Interstate Treaty on Media (MStV)
            </strong>
        </p>
        <p>
            Robert Bosch GmbH<br/>
            Dr. Michael Schmidtke<br/>
            Robert-Bosch-Platz 1<br/>
            70839 Gerlingen-Schillerhoehe<br/>
            GERMANY
        </p>
    </div>
</div>
